module.exports = "/assets/landing-rwx/instagram/insta-feed-5.jpg?t8HH+UI";